import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Login18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_625)'>
      <path
        d='M8.2176 0.691786L3.57959 5.32968L4.64025 6.39034L9.12992 1.90067L16.2293 9.00001L9.12992 16.0993L4.64025 11.6097L3.57959 12.6703L8.20953 17.3004L8.2176 17.3082C8.71889 17.7947 9.54098 17.7948 10.0423 17.3083L17.4257 9.92486C17.9393 9.42547 17.9393 8.5746 17.4258 8.07518L10.0503 0.699616L10.0422 0.691786C9.5409 0.205257 8.71894 0.205256 8.2176 0.691786Z'
        fill='currentColor'
      />
      <path
        d='M8.53039 5.46967L12.0607 9L8.53039 12.5303L7.46973 11.4697L9.18939 9.75001H0.25V8.25001H9.1894L7.46973 6.53033L8.53039 5.46967Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_625'>
        <rect width='18' height='18' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Login18.displayName = 'Login18';
export default Login18;
